import React, { useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useNavigate } from "../../../components/Navigate";
import MainLayout from "../../../components/layout/MainLayout";
import ScreenWrapper from "../../../components/layout/screenWrapper";
import {
  boyReportsRegistry,
  moyReportsRegistry,
  TDOE_CHART_TYPES,
} from "../components/reports/tdoeReportsRegistry";

import "../reportsMgmt.scss";

const getReportUrl = (report) => {
  let url;
  switch (report.chartType) {
    case TDOE_CHART_TYPES.PIE:
      url = "/report/tdoe-pie-chart";
      break;
    case TDOE_CHART_TYPES.BAR:
      url = "/report/tdoe-bar-chart";
      break;
    case TDOE_CHART_TYPES.STACKED_BAR:
      url = "/report/tdoe-stacked-bar-chart";
      break;
    case TDOE_CHART_TYPES.CLUSTER_BAR:
      url = "/report/tdoe-cluster-bar-chart";
      break;
    case TDOE_CHART_TYPES.PERIOD_BREAKDOWN:
      url = "/report/tdoe-period-breakdown-chart";
      break;
    default:
      url = "/report/tdoe-bar-chart";
  }

  const params = new URLSearchParams();
  params.set("title", report.title);
  params.set("dcp", report.dataCollectionPeriod);

  if (report.chartType === TDOE_CHART_TYPES.CLUSTER_BAR) {
    params.set("gradeLevel", report.gradeLevel);
    params.set("coreAction", report.coreAction);
  } else {
    params.set("qstf", report.questionSurveyTemplateFieldId);
    if (report.defaultGroupBy) {
      params.set("groupBy", report.defaultGroupBy);
    }
  }

  return `${url}?${params.toString()}`;
};

const DataDashboardReportsMgmt = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const screen = window.document.getElementsByClassName("screen");
    if (screen.length > 0) {
      screen[0].scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  const handleReportClick = (report) => {
    navigate(getReportUrl(report), { state: "VISITED" });
  };

  const renderReportEntries = (registry) =>
    registry.map((report) => (
      <div className="categoryWrapper" key={report.id}>
        {report.hasDefinition ? (
          <h3
            className="categoryTitle report report-title"
            onClick={() => handleReportClick(report)}
          >
            {report.title}
          </h3>
        ) : (
          <h3 className="categoryTitle report report-title no-link">
            {report.title}
            <span className="coming-soon-badge">Coming soon</span>
          </h3>
        )}
        <h4 className="report-description">
          {report.hasDefinition
            ? "Click to view the TDOE report."
            : "This report is not yet available."}
        </h4>
      </div>
    ));

  return (
    <>
      <MainLayout>
        <ScreenWrapper loading={false} loadingError={false} onReturn={() => {}}>
          <div className="reports">
            <div className="categoryWrapper reports-title">
              <h1>Data Dashboard Reports</h1>
            </div>
            <div className="contentDisplay">
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <h2>Beginning of Year (BOY)</h2>
                </AccordionSummary>
                <AccordionDetails>
                  {renderReportEntries(boyReportsRegistry)}
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <h2>Middle of Year (MOY)</h2>
                </AccordionSummary>
                <AccordionDetails>
                  {renderReportEntries(moyReportsRegistry)}
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </ScreenWrapper>
      </MainLayout>
    </>
  );
};

export default DataDashboardReportsMgmt;
